import {
  APPROVE_SUCCESS_STORY,
  APPROVE_SUCCESS_STORY_FAILURE,
  APPROVE_SUCCESS_STORY_SUCCESS,
  CREATE_SUCCESS_STORY,
  CREATE_SUCCESS_STORY_FAILURE,
  CREATE_SUCCESS_STORY_SUCCESS,

  EMPTY_FETCH_SUCCESS_STORY_WITHOUT_PAGINATION,

  FETCH_ALL_SUCCESS_STORY,
  FETCH_ALL_SUCCESS_STORY_FAILURE,
  FETCH_ALL_SUCCESS_STORY_SUCCESS,

  FETCH_SUCCESS_STORY_BY_ID,
  FETCH_SUCCESS_STORY_BY_ID_FAILURE,
  FETCH_SUCCESS_STORY_BY_ID_SUCCESS,

  FETCH_SUCCESS_STORY_WITHOUT_PAGINATION,
  FETCH_SUCCESS_STORY_WITHOUT_PAGINATION_FAILURE,
  FETCH_SUCCESS_STORY_WITHOUT_PAGINATION_SUCCESS,

  FETCH_TOTAL_SUCCESS_STORY,
  FETCH_TOTAL_SUCCESS_STORY_FAILURE,
  FETCH_TOTAL_SUCCESS_STORY_SUCCESS,

  RESTORE_STORY_INITIAL,

  UPDATE_SUCCESS_STORY,
  UPDATE_SUCCESS_STORY_FAILURE,
  UPDATE_SUCCESS_STORY_SUCCESS,
} from "../ActionTypes";

// To add new success story
export const addSuccessStory = (payload) => ({
  type: CREATE_SUCCESS_STORY,
  payload,
});

export const addSuccessStorySuccess = (payload) => ({
  type: CREATE_SUCCESS_STORY_SUCCESS,
  payload,
});

export const addSuccessStoryFailure = (payload) => ({
  type: CREATE_SUCCESS_STORY_FAILURE,
  payload,
});

// To fetch all success story
export const fetchSuccessStory = (payload) => ({
  type: FETCH_ALL_SUCCESS_STORY,
  payload,
});

export const fetchSuccessStorySuccess = (payload) => ({
  type: FETCH_ALL_SUCCESS_STORY_SUCCESS,
  payload,
});

export const fetchSuccessStoryFailure = (payload) => ({
  type: FETCH_ALL_SUCCESS_STORY_FAILURE,
  payload,
});

// to restore story
export const restoreStoryInitial = () => ({
  type: RESTORE_STORY_INITIAL,
});

// To update Success Story
export const updateSuccessStory = (payload) => ({
  type: UPDATE_SUCCESS_STORY,
  payload,
});
export const updateSuccessStorySuccess = (payload) => ({
  type: UPDATE_SUCCESS_STORY_SUCCESS,
  payload,
});
export const updateSuccessStoryFailure = (payload) => ({
  type: UPDATE_SUCCESS_STORY_FAILURE,
  payload,
});

// fetch story without pagination
export const fetchSuccessStoryWithoutPagination = () => ({
  type: FETCH_SUCCESS_STORY_WITHOUT_PAGINATION,
});

export const fetchSuccessStoryWithoutPaginationSuccess = (payload) => ({
  type: FETCH_SUCCESS_STORY_WITHOUT_PAGINATION_SUCCESS,
  payload,
});

export const fetchSuccessStoryWithoutPaginationFailure = (payload) => ({
  type: FETCH_SUCCESS_STORY_WITHOUT_PAGINATION_FAILURE,
  payload,
});

export const emptyFetchSuccessStoryWithoutPagination = () => ({
  type: EMPTY_FETCH_SUCCESS_STORY_WITHOUT_PAGINATION,
});

// fetch total success story details
export const fetchTotalSuccessStory = () => ({
  type: FETCH_TOTAL_SUCCESS_STORY,
});

export const fetchTotalSuccessStorySuccess = (payload) => ({
  type: FETCH_TOTAL_SUCCESS_STORY_SUCCESS,
  payload,
});

export const fetchTotalSuccessStoryFailure = (payload) => ({
  type: FETCH_TOTAL_SUCCESS_STORY_FAILURE,
  payload,
});

// To fetch all Success Story by id
export const fetchSuccessStoryById = (payload) => ({
  type: FETCH_SUCCESS_STORY_BY_ID,
  payload,
});

export const fetchSuccessStoryByIdSuccess = (payload) => ({
  type: FETCH_SUCCESS_STORY_BY_ID_SUCCESS,
  payload,
});

export const fetchSuccessStoryByIdFailure = (payload) => ({
  type: FETCH_SUCCESS_STORY_BY_ID_FAILURE,
  payload,
});

// To approve Success Story
export const approveSuccessStory = (payload) => ({
  type: APPROVE_SUCCESS_STORY,
  payload,
});
export const approveSuccessStorySuccess = (payload) => ({
  type: APPROVE_SUCCESS_STORY_SUCCESS,
  payload,
});
export const approveSuccessStoryFailure = (payload) => ({
  type: APPROVE_SUCCESS_STORY_FAILURE,
  payload,
});